export default __webpack_public_path__ + "static/media/dogHorse.c4f25959.png";